import BaseModel from "../base_model.js";

import { InputLabelDisplayModeAbove, TextFieldCapitalizationUppercase } from "../../base/inputs/constants.js";

class RawUserPaymentMethodModel extends BaseModel {
  rawFormFields(item = undefined, config = {}) {
    return [
      {
        name: "number",
        displayName: this.fieldDisplayName("number"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: config.weight,
        capitalization: TextFieldCapitalizationUppercase,
        forceNextLine: true
      },
      {
        name: "bic",
        displayName: this.fieldDisplayName("bic"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: config.weight,
        forceNextLine: true
      },
      {
        name: "accountOwner",
        displayName: this.fieldDisplayName("accountOwner"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: config.weight,
        forceNextLine: true
      },
    ]
  }

  i18nScope() {
    return "model.users.payment_method";
  }
}

const UserPaymentMethodModel = new RawUserPaymentMethodModel();

export { RawUserPaymentMethodModel, UserPaymentMethodModel }
